export class TimesOfDay {
  static MORNING = 1;
  static AFTERNOON = TimesOfDay.MORNING << TimesOfDay.MORNING;
  static EVENING = TimesOfDay.AFTERNOON << TimesOfDay.MORNING;
  static ALL = TimesOfDay.MORNING + TimesOfDay.AFTERNOON + TimesOfDay.EVENING;
}

export type TimeOfDay = 'morning' | 'afternoon' | 'evening' | 'all';